import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";
import { CheckCircle, XCircle, AlertTriangle, Info } from "lucide-react";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "light" } = useTheme(); // Force light theme for testing

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        unstyled: true, // This disables default styles
        classNames: {
          toast: 
            "w-full flex items-center gap-2 p-4 mb-2 rounded-md border shadow-md",
          description: "text-sm",
          actionButton: "bg-primary text-primary-foreground px-3 py-1 rounded-md",
          cancelButton: "bg-muted text-muted-foreground px-3 py-1 rounded-md",
          
          // Custom variants
          success: "bg-green-50 border-green-500 text-green-900 border-l-4",
          error: "bg-red-50 border-red-500 text-red-900 border-l-4",
          warning: "bg-amber-50 border-amber-500 text-amber-900 border-l-4",
          info: "bg-blue-50 border-blue-500 text-blue-900 border-l-4",
        },
      }}
      icons={{
        success: <CheckCircle className="h-5 w-5 text-green-500" />,
        error: <XCircle className="h-5 w-5 text-red-500" />,
        warning: <AlertTriangle className="h-5 w-5 text-amber-500" />,
        info: <Info className="h-5 w-5 text-blue-500" />,
      }}
      {...props}
    />
  );
};

export { Toaster };